export const TEMPLATE_HREF = "/farmer_kyc_enable_template.xlsx";
export const NO_ENTRIES_TOAST_MESSAGE = "No entries added";
